import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import SuggestionWidget from "../suggestions/components/SuggestionWidget/SuggestionWidget.jsx";
import ContactWidget from "../contact/Components/ContactWidget.jsx";

const container = document.getElementById("suggestions-contact-widget-container");
const configContainer = document.getElementById("suggestions-contact-widget-config");  
let configuration = "";
if (configContainer) {
  configuration = JSON.parse(configContainer.innerText);
}

if (container){
  const root = createRoot(container);
  root.render(
   
        <div className="flex-column flex-md-row d-flex flex-md-nowrap gap-2">
          <div className="col-12 col-md-6 p-0 ">
            <ContactWidget config={configuration}/>
          </div>
          <div className="col-12 col-md-6 p-0 mt-4 mt-md-0" >
            <SuggestionWidget config={configuration}/>
          </div>
        </div>
     
  );
}
